import styled from "styled-components";

import { ContactUsCardStyledProps as Props } from "./ContactUsCard.types";
import { CONSTANTS } from "config/constants";

const { mobile } = CONSTANTS.BREAKPOINTS;

const ContactUsCardStyled = styled.div<Props>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--palette-white);
  border-radius: 1.2rem;
  padding: 2.4rem 1.2rem;

  .ContactUsCard {
    &__title {
      color: var(--palette-gray-s0-l70);
      font-size: 1.6rem;
      line-height: 1.2rem;
      padding-bottom: 0.4rem;
    }

    &__subTitle {
      font-weight: 600;
      font-size: 1.6rem;
      line-height: 2rem;

      @media (max-width: ${mobile}px) {
        max-width: 18rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &__link {
      background-color: var(--palette-gray-s0-l95);
      padding: 0.8rem 2rem;
      border-radius: 10rem;
      text-decoration: none;
      font-size: 1.6rem;
      font-weight: 600;
      line-height: 2rem;
      color: var(--palette-black);
    }
  }
`;

export default ContactUsCardStyled;
